import React from 'react';
import { Button, Modal, Text, useNotify } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { useMutation } from 'react-query';
import { disableEnforceMfa, useSites } from '@hotjar/site';

interface Props {
  siteId: number;
  onClose(): void;
  opened: boolean;
}

const TRANSLATION_DOMAIN = 'account:unenforce-2fa-modal';

export function UnenforceSiteMfaModal({ siteId, opened, onClose }: Props): React.ReactElement {
  const { t } = useTranslationWithPrefix(TRANSLATION_DOMAIN);
  const { showToast } = useNotify();
  const { invalidate } = useSites();

  const mutation = useMutation(
    async () => {
      return disableEnforceMfa(siteId).then((response) => {
        if (response.status !== 200) {
          throw new Error();
        }
      });
    },
    {
      onSuccess: async () => {
        showToast({
          text: t('success-message'),
          kind: 'success',
        });
        invalidate();
        onClose();
      },
      onError: () => {
        showToast({ text: t('error-message'), kind: 'danger' });
      },
    },
  );

  const handleSubmit = () => {
    mutation.mutate();
  };

  return (
    <Modal isOpen={opened} size="m" contentLabel={t('title')} onClose={onClose}>
      <Modal.Header title={t('title')} />
      <Modal.Body>
        <Text as="p">{t('description')}</Text>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={onClose} isDisabled={mutation.isLoading}>
          {t('cancel')}
        </Button>
        <Button kind="primary" type="button" onClick={handleSubmit} isLoading={mutation.isLoading}>
          {t('stop-requiring-2fa')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
